export default {
	cnumber1: '役割リスト',
	cnumber2: 'サブアカウントリスト',
	cnumber3: 'ロール識別子',
	cnumber4: 'ロール名',
	cnumber5: 'ロール権限',
	cnumber6: '有効',
	cnumber7: '無効',
	cnumber8: '削除しますか？',
	cnumber9: 'サブアカウント状態',
	cnumber10: 'サブアカウント追加',
	cnumber11: 'サブアカウントID',
	cnumber12: 'ロール',
	cnumber13: '最終ログイン時間',
	cnumber14: '権限',
	cnumber15: 'サブアカウント編集',
	cnumber16: 'ロールメニュー',
	cnumber17: '一括割り当て',
	cnumber18: 'まず注文を選択してください',
	cnumber19: '注文割り当て',
	cnumber20: 'サブアカウント',
	cnumber21: '同捆',
	cnumber22: '商品出荷指示',
	cnumber31: '全て（全てのアカウントのデータを操作できます）',
	cnumber24: '自分',
	cnumber25: 'ロール状態',
	cnumber26: 'この操作は',
	cnumber27: '続けますか？',
	cnumber28: '6～20文字の英数字を組み合わせたパスワードを入力してください',
	cnumber29: '充値アカウント',
	cnumber30: '担当者',
	cnumber31: '全て（全てのアカウントのデータを閲覧できます）',
};
